<div :class="{'format-container': true, 'crop-mode': getEditor.cropMode}">
  <div
    v-show="getEditor.marginView"
    :class="{layerH: isHor, layerV: isVer, layerR: isRou, marginViewPlaceHolder: true}"
    :style="[getMarginViewStyle,getMarginViewBg]"
  >
    <div
      v-show="getMirrored"
      :style="getMirroredTopStyle"
      class="topMirrored mirroredDiv"
    ></div>
    <div
      v-show="getMirrored"
      :style="getMirroredRightStyle"
      class="rightMirrored mirroredDiv"
    ></div>
    <div
      v-show="getMirrored"
      :style="getMirroredBottomStyle"
      class="bottomMirrored mirroredDiv"
    ></div>
    <div
      v-show="getMirrored"
      :style="getMirroredLeftStyle"
      class="leftMirrored mirroredDiv"
    ></div>
    <div
      v-show="getRandOption"
      :style="getMarginTopStyle"
      class="topMarginDiv marginDiv"
    >
      {{$t("Rand") }}
    </div>
    <div
      v-show="getRandOption"
      :style="getMarginRightStyle"
      class="rightMarginDiv marginDiv"
    >
      <span>{{$t("Rand")}}</span>
    </div>
    <div
      v-show="getRandOption"
      :style="getMarginBottomStyle"
      class="bottomMarginDiv marginDiv"
    >
      {{$t("Rand") }}
    </div>
    <div
      v-show="getRandOption"
      :style="getMarginLeftStyle"
      class="leftMarginDiv marginDiv"
    >
      <span>{{$t("Rand")}}</span>
    </div>
  </div>
  <drop class="drop" @drop="handleDrop">
    <div ref="formatLayer"
      v-show="getFormat.show"
      id="format-layer"
      :class="{layerH: isHor, layerV: isVer, layerR: isRou}"
      :style="[getStyle, getBackgroundStyle]"
    >
      <div id="format-crop-layer" :class="{layerR: isRou}" :style="getCropStyle">
        <div v-if="getMargin.rand_option" id="format-layer-dashed"></div>
        <appWallpaperLines></appWallpaperLines>
        <appCornersFormat></appCornersFormat>
        <appLayerEditor :type="'steckdosen'"></appLayerEditor>
        <appLayerEditor :type="'cutouts'"></appLayerEditor>
        <appLayerEditor :type="'objects'"></appLayerEditor>
        <div v-if="!getFormat.rounded" class="formatInfo formatW">
          {{getFormat.width}} {{$t('cm') }}
        </div>
        <div class="formatInfo formatH">
          {{getFormat.height}}{{$t('cm') }}
        </div>
      </div>
      <u></u>
      <u class="whiteB"></u>
    </div>
  </drop>
  <div v-show="getEditor.marginView" class="marginViewDummyPlaceHolder"></div>
</div>
